export const PAGE = {
    LOGIN : '/user/login',
    ADMIN : 'admin/tasks',
    TASKS : '/admin/tasks',
    ADMIN_AGENTS : '/admin/agents',
}